import type {
    ICreateExternalClientPayload,
    IEditExternalClientPayload,
    IExternalClient,
    IExternalClientSecretPayload,
    ISecret,
} from '@experiences/interfaces';

import {
    axiosDelete,
    get,
    post,
    put,
} from '../utility/Requests';
import { getIdentityBaseRoute } from './IdentityServiceUtils';

export const externalClientUrl = `/api/identity/ExternalClient`;

// Helper function to get direct Identity service URL
const getDirectExternalClientUrl = (partitionGlobalId: string, isHostMode: boolean = false) =>
    `${getIdentityBaseRoute(partitionGlobalId, isHostMode)}/api/ExternalClient`;

export function getExternalClients({
    partitionGlobalId, isHostMode = false,
}: { url: string; partitionGlobalId: string; isHostMode?: boolean }) {
    const directUrl = `${getDirectExternalClientUrl(partitionGlobalId, isHostMode)}/${partitionGlobalId}`;
    return get<IExternalClient[]>(directUrl, { ignoreBasePath: true });
}

export function getExternalClientById({
    partitionGlobalId, id, isHostMode = false,
}: { url: string; partitionGlobalId: string; id: string; isHostMode?: boolean }) {
    const directUrl = `${getDirectExternalClientUrl(partitionGlobalId, isHostMode)}/${partitionGlobalId}/${id}`;
    return get<IExternalClient>(directUrl, { ignoreBasePath: true });
}

export async function createExternalClient(payload: ICreateExternalClientPayload, isHostMode: boolean = false) {
    const directUrl = getDirectExternalClientUrl(payload.partitionGlobalId, isHostMode);
    return post<IExternalClient>(directUrl, {
        body: payload,
        ignoreBasePath: true,
    });
}

export function editExternalClient(id: string, payload: IEditExternalClientPayload, isHostMode: boolean = false) {
    const directUrl = `${getDirectExternalClientUrl(payload.partitionGlobalId, isHostMode)}/${payload.partitionGlobalId}/${id}`;
    return put<IExternalClient>(directUrl, {
        body: payload,
        ignoreBasePath: true,
    });
}

export function deleteExternalClient(id: string, partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = `${getDirectExternalClientUrl(partitionGlobalId, isHostMode)}/${partitionGlobalId}/${id}`;
    return axiosDelete(directUrl, { ignoreBasePath: true });
}

export async function createClientSecret(payload: IExternalClientSecretPayload, isHostMode: boolean = false) {
    const directUrl = `${getDirectExternalClientUrl(payload.partitionGlobalId, isHostMode)}/GenerateSecret`;
    return post<ISecret>(directUrl, {
        body: payload,
        ignoreBasePath: true,
    });
}

export function deleteClientSecret(secretId: string, partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = `${getDirectExternalClientUrl(partitionGlobalId, isHostMode)}/${partitionGlobalId}/secrets/${secretId}`;
    return axiosDelete(directUrl, { ignoreBasePath: true });
}
